/* eslint-disable complexity, max-statements, @typescript-eslint/no-non-null-assertion */
// TODO - Abstract copies into language constants - over the limit, left, characters entered
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Icon, Typography } from '../';
import * as S from './styles';
export var Input = forwardRef(function Input(props, ref) {
    var id = props.id, name = props.name, defaultValue = props.defaultValue, value = props.value, placeholder = props.placeholder, error = props.error, disabled = props.disabled, width = props.width, iconPosition = props.iconPosition, icon = props.icon, iconColor = props.iconColor, inputProps = props.inputProps, multiline = props.multiline, multilineResizable = props.multilineResizable, autoFocus = props.autoFocus, rows = props.rows, rowsMax = props.rowsMax, type = props.type, startAdornment = props.startAdornment, endAdornment = props.endAdornment, onChange = props.onChange, limit = props.limit, counter = props.counter, enableReset = props.enableReset, onResetClick = props.onResetClick, className = props.className, style = props.style;
    var clearInput = function () {
        if (onResetClick) {
            onResetClick();
        }
        else if (onChange) {
            var emptyEvent = { target: { value: '' } };
            onChange(emptyEvent); // clear input (works only outside Formik)
        }
    };
    // Generate counter for single line input
    var counterSingleLine;
    if (!multiline) {
        if (limit && counter === 'remaining') {
            var overLimitCount = limit - (value ? value.length : 0);
            var isOverLimit = overLimitCount < 0;
            counterSingleLine = React.createElement(Typography, { color: isOverLimit ? 'danger' : 'extra-light' }, overLimitCount);
        }
        else if (counter === 'entered') {
            counterSingleLine = React.createElement(Typography, { color: 'extra-light' }, value ? value.length : 0);
        }
    }
    // Generate counter for multiline input
    var counterMultiLine;
    if (multiline) {
        if (limit && counter === 'remaining') {
            var overLimitCount = limit - (value ? value.length : 0);
            var isOverLimit = overLimitCount <= 0;
            counterMultiLine = (React.createElement(Typography, { color: isOverLimit ? 'danger' : 'extra-light' },
                Math.abs(overLimitCount),
                " ",
                overLimitCount === 0 ? '' : isOverLimit ? 'over the limit' : 'left'));
        }
        else if (counter === 'entered') {
            counterMultiLine = React.createElement(Typography, { color: 'extra-light' },
                value ? value.length : 0,
                " characters entered");
        }
    }
    var renderIcon = icon && React.createElement(Icon, { name: icon, color: iconColor, size: 'small' });
    var renderStartAdornment = (startAdornment || renderIcon) && (React.createElement(React.Fragment, null,
        iconPosition === 'left' && renderIcon,
        startAdornment));
    var renderEndAdornment = (endAdornment || renderIcon || enableReset || counterSingleLine || counterMultiLine) && (React.createElement(React.Fragment, null, counterMultiLine ? (React.createElement(S.CounterMultiLine, null, counterMultiLine)) : (React.createElement(React.Fragment, null,
        enableReset && (React.createElement(S.ResetButton, { className: 'reset-button', onClick: clearInput },
            React.createElement(Icon, { name: 'cross', color: 'grey', size: 12 }))),
        counterSingleLine,
        endAdornment,
        iconPosition === 'right' && renderIcon))));
    var resizableClass = multilineResizable ? 'is-resizable' : false;
    var counterMultilineClass = counterMultiLine ? 'multiline-has-counter' : false;
    var rootClass = cx(resizableClass, counterMultilineClass, className);
    return (React.createElement(S.Input, { id: id, name: name, defaultValue: defaultValue, value: value, onChange: onChange, placeholder: placeholder, multiline: multiline, rows: rows, rowsMax: rowsMax, error: error, type: type, disabled: disabled, className: rootClass, style: style, inputProps: inputProps, fullWidth: width === 'full', autoFocus: autoFocus, startAdornment: renderStartAdornment, endAdornment: renderEndAdornment, inputRef: ref }));
});
Input.defaultProps = {
    counter: 'remaining',
    iconPosition: 'left',
    iconColor: 'light-grey',
    multiline: false,
    width: 'auto'
};
Input.displayName = 'Input';
export default Input;
//# sourceMappingURL=Input.js.map